import { useState } from "react";
import api from "@/lib/api";
import { PLESSI } from "./utils";
import { VocePicker } from "./VocePicker";

export function AddRigaModal({ id_doc, onClose }) {
  const [conto, setConto] = useState(null);
  const [voceDescr, setVoceDescr] = useState("");
  const [plesso, setPlesso] = useState("INFANZIA");
  const [importo, setImporto] = useState("");
  const [pickerOpen, setPickerOpen] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  const aggiungi = async () => {
    if (!conto || !importo) return;
    setSaving(true); setErr(null);
    try {
      await api.post(`/pn/fatture/${id_doc}/righe`, { conto: Number(conto), plesso, importo: Number(importo) });
      onClose();
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setSaving(false); }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "white", width: 600, display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#2e7d32", color: "white", padding: "8px 14px", fontWeight: 700, display: "flex", alignItems: "center", gap: 10 }}>
          <span>+ Aggiungi riga contabilità</span>
          <span style={{ flex: 1 }} />
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: "white", fontSize: 18, cursor: "pointer" }}>✕</button>
        </div>
        {err && <div style={{ padding: 8, background: "#fff0f0", color: "#c00", fontSize: 12, fontWeight: 700 }}>{err}</div>}
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#37474f", marginBottom: 4 }}>VOCE DI BILANCIO</div>
            <button onClick={() => setPickerOpen(true)} data-testid="pn-addriga-pick"
              style={{ padding: "6px 14px", background: conto ? "#0d47a1" : "#0288d1", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              🌲 {conto ? `[${conto}] cambia voce` : "Scegli voce dal Piano dei Conti"}
            </button>
            {conto && voceDescr && (
              <div style={{ marginTop: 6, padding: "6px 10px", background: "#e8f5e9", border: "1px solid #4caf50", fontSize: 12, fontWeight: 700, color: "#1b5e20" }}>
                ✓ <span style={{ fontFamily: "monospace" }}>[{conto}]</span> {voceDescr}
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#37474f", marginBottom: 4 }}>SETTORE</div>
              <select value={plesso} onChange={e => setPlesso(e.target.value)} data-testid="pn-addriga-plesso"
                style={{ width: "100%", padding: "6px 8px", fontSize: 12, border: "1px solid #888" }}>
                {PLESSI.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#37474f", marginBottom: 4 }}>IMPORTO €</div>
              <input type="number" step="0.01" placeholder="0,00" value={importo} onChange={e => setImporto(e.target.value)} data-testid="pn-addriga-importo"
                style={{ width: "100%", padding: "6px 10px", border: "1px solid #888", fontSize: 13, fontFamily: "monospace", textAlign: "right", fontWeight: 700 }} />
            </div>
          </div>
        </div>
        <div style={{ padding: 8, display: "flex", gap: 8, justifyContent: "flex-end", background: "#fafafa" }}>
          <button onClick={onClose} style={{ padding: "5px 14px", background: "white", border: "1px solid #555", cursor: "pointer" }}>Annulla</button>
          <button onClick={aggiungi} disabled={!conto || !importo || saving} data-testid="pn-addriga-save"
            style={{ padding: "5px 14px", background: !conto || !importo ? "#ccc" : "#2e7d32", color: "white", border: "none", fontWeight: 700, cursor: !conto || !importo ? "not-allowed" : "pointer" }}>
            {saving ? "..." : "+ Aggiungi"}
          </button>
        </div>
      </div>
      <VocePicker open={pickerOpen} value={conto} onClose={() => setPickerOpen(false)}
        onSelect={v => { setConto(v.id_conto); setVoceDescr(v.descrizione); setPickerOpen(false); }} />
    </div>
  );
}
